const mfa = {
    title: 'การยืนยันตัวตนแบบหลายปัจจัย',
    description: 'เพิ่มการยืนยันตัวตนแบบหลายปัจจัยเพื่อเสริมความปลอดภัยให้กับประสบการณ์การเข้าสู่ระบบของคุณ',
    factors: 'ปัจจัย',
    multi_factors: 'หลายปัจจัย',
    multi_factors_description: 'ผู้ใช้ต้องยืนยันหนึ่งในปัจจัยที่เปิดใช้งานสำหรับการยืนยันตัวตนแบบ 2 ขั้นตอน',
    totp: 'รหัส OTP จากแอปพลิเคชันยืนยันตัวตน',
    otp_description: 'เชื่อมต่อ Google Authenticator ฯลฯ เพื่อตรวจสอบรหัสผ่านแบบครั้งเดียว',
    webauthn: 'WebAuthn (Passkey)',
    webauthn_description: 'ยืนยันผ่านวิธีที่เบราว์เซอร์รองรับ: ไบโอเมตริกส์, สแกนโทรศัพท์ หรือคีย์ความปลอดภัย ฯลฯ',
    webauthn_native_tip: 'WebAuthn ไม่รองรับสำหรับแอปพลิเคชัน Native',
    webauthn_domain_tip: 'WebAuthn จะผูกคีย์สาธารณะกับโดเมนโดยเฉพาะ หากมีการเปลี่ยนแปลงโดเมนของบริการ จะทำให้ผู้ใช้ไม่สามารถยืนยันตัวตนผ่าน Passkey เดิมได้',
    backup_code: 'รหัสสำรอง',
    backup_code_description: 'สร้างรหัสสำรองแบบใช้ครั้งเดียว 10 รหัสหลังจากผู้ใช้ตั้งค่าการใช้งาน MFA ใด ๆ',
    backup_code_setup_hint: 'หากผู้ใช้ไม่สามารถยืนยันตัวตนด้วยปัจจัย MFA ด้านบน ให้ใช้ตัวเลือกสำรองนี้',
    backup_code_error_hint: 'ในการใช้รหัสสำรอง จำเป็นต้องมีวิธี MFA อย่างน้อยอีกหนึ่งวิธีเพื่อให้ยืนยันตัวตนผู้ใช้สำเร็จ',
    email_verification_code: 'รหัสยืนยันอีเมล',
    email_verification_code_description: 'เชื่อมต่ออีเมลเพื่อรับและยืนยันรหัสยืนยัน',
    phone_verification_code: 'รหัสยืนยัน SMS',
    phone_verification_code_description: 'เชื่อมต่อหมายเลขโทรศัพท์เพื่อรับและยืนยันรหัสผ่าน SMS',
    policy: 'นโยบาย',
    policy_description: 'ตั้งค่านโยบาย MFA สำหรับขั้นตอนการเข้าสู่ระบบและสมัครสมาชิก',
    two_step_sign_in_policy: 'นโยบายการยืนยันตัวตนแบบ 2 ขั้นตอนขณะเข้าสู่ระบบ',
    user_controlled: 'ผู้ใช้สามารถเปิดหรือปิด MFA ได้ด้วยตนเอง',
    user_controlled_tip: 'ผู้ใช้สามารถข้ามขั้นตอนติดตั้ง MFA ในการเข้าสู่ระบบหรือสมัครสมาชิกครั้งแรก หรือเปิด/ปิดได้ในหน้าการตั้งค่าบัญชี',
    mandatory: 'ผู้ใช้ต้องยืนยันตัวตนด้วย MFA ทุกครั้งที่เข้าสู่ระบบ',
    mandatory_tip: 'ผู้ใช้ต้องตั้งค่า MFA ในการเข้าสู่ระบบหรือสมัครสมาชิกครั้งแรก และต้องใช้งานทุกครั้งที่เข้าสู่ระบบในอนาคต',
    require_mfa: 'บังคับใช้ MFA',
    require_mfa_label: 'เปิดใช้งานเพื่อบังคับให้ต้องมีการยืนยันตัวตนแบบ 2 ขั้นตอนในการเข้าถึงแอปพลิเคชันของคุณ หากปิดใช้งาน ผู้ใช้สามารถเลือกว่าจะเปิดใช้ MFA หรือไม่',
    set_up_prompt: 'ข้อความเตือนให้ตั้งค่า MFA',
    no_prompt: 'ไม่ขอให้ผู้ใช้ตั้งค่า MFA',
    prompt_at_sign_in_and_sign_up: 'ขอให้ผู้ใช้ตั้งค่า MFA ขณะสมัครสมาชิก (สามารถข้ามได้ แจ้งเตือนเพียงครั้งเดียว)',
    prompt_only_at_sign_in: 'ขอให้ผู้ใช้ตั้งค่า MFA ในการเข้าสู่ระบบครั้งถัดไปหลังสมัครสมาชิก (สามารถข้ามได้ แจ้งเตือนเพียงครั้งเดียว)',
    set_up_organization_required_mfa_prompt: 'ข้อความแจ้งตั้งค่า MFA หลังจากองค์กรเปิดใช้ MFA แล้ว',
    prompt_at_sign_in_no_skip: 'ขอให้ผู้ใช้ตั้งค่า MFA ในการเข้าสู่ระบบครั้งถัดไป (ไม่สามารถข้ามได้)',
    email_primary_method_tip: 'รหัสยืนยันอีเมลถูกใช้เป็นวิธีหลักในการเข้าสู่ระบบของคุณอยู่แล้ว เพื่อความปลอดภัยจึงไม่สามารถใช้ซ้ำสำหรับ MFA ได้',
    phone_primary_method_tip: 'รหัสยืนยัน SMS ถูกใช้เป็นวิธีหลักในการเข้าสู่ระบบของคุณอยู่แล้ว เพื่อความปลอดภัยจึงไม่สามารถใช้ซ้ำสำหรับ MFA ได้',
};
export default Object.freeze(mfa);
